import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useTouchSupported = () => {
  const desktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const [touchSupported, setTouchSupported] = useState(!desktopEmbedded);

  useEffect(() => {
    setTouchSupported('ontouchstart' in document.documentElement && !desktopEmbedded);
  }, [setTouchSupported, desktopEmbedded]);

  return touchSupported;
};

export default useTouchSupported;
